import { Badge, Card, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'helpers/api';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import paths from 'routes/paths';
import ResetPasswordModal from '../add-facility-staff/ResetPasswordModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import AccessHistory from './AccessHistory';
import isHiddenFacility from 'helpers/isHiddenFacility';

const AccessIconBadge = ({ enabled, label, icon }) => {
    if (enabled === null || enabled === undefined) {
        return <span className="text-400">-</span>;
    }

    const isEnabled = Number(enabled) === 1;

    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip style={{ position: 'fixed' }}>{`${label}: ${isEnabled ? 'Enabled' : 'Disabled'}`}</Tooltip>}
        >
            <Badge
                bg={isEnabled ? 'success' : 'secondary'}
                className={`rounded-pill px-2 py-1 ${isEnabled ? 'bg-opacity-75' : 'bg-opacity-50'}`}
            >
                <FontAwesomeIcon
                    icon={isEnabled ? icon : 'ban'}
                    className="me-1"
                />
                {isEnabled ? 'On' : 'Off'}
            </Badge>
        </OverlayTrigger>
    );
};

const ViewFacilityStaff = () => {
    const roleId = Number(localStorage.getItem('roleId'));
    //const [facility] = useState(facilityStaffData);
    const [allFacilityStaff, setAllFacilityStaff] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [accessUserId, setAccessUserId] = useState(null);
    const [accessUsername, setAccessUsername] = useState('');
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const navigate = useNavigate();
    const currentRoleId = Number(localStorage.getItem("roleId"));
    const canFilterByGroup = currentRoleId < 4;
    const allRoleOptions = [{ key: 'All Roles', value: '' },
    { key: "Pharmacy Admin", value: 2 },
    { key: "Pharmacy Staff", value: 3 },
    { key: "Group Admin", value: 4 },
    { key: "Facility Staff", value: 5 },
    { key: "Day Program User", value: 6 },
    { key: "Care Giver User", value: 7 },
];
    const roleOptions = currentRoleId === 4
        ? allRoleOptions.filter(option => ![2, 3].includes(option.value))
        : allRoleOptions;
    const roleMapping = {
        7: "Care Giver User",
        6: "Day Program User",
        5: "Facility Staff",
        4: "Group Admin",
        3: "PHARMACY Staff",
        2: "Pharmacy Admin",
        1: "System Admin"
    };
    const columns = [
        {
            accessorKey: 'name',
            header: 'Username',
            meta: {
                headerProps: { className: 'pe-1 text-900' }
            },
            cell: ({ row: { original } }) => {
                const viewfacilitystaffprofile = paths.viewfacilitystaffprofile
                return <Link to={{ pathname: `${viewfacilitystaffprofile}/${original.id}` }} state={{
                    userid: original.id
                }} >
                    {original.name}</Link>
            }
        },
        {
            accessorKey: 'fullname',
            header: 'Fullname',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        {
            accessorKey: 'role',
            header: 'Role',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        {
            accessorKey: 'mobile',
            header: 'Mobile',
            meta: {
                headerProps: { className: 'ps-5 text-900' }
            }
        },
        {
            accessorKey: 'email',
            header: 'Email',
            meta: {
                headerProps: { className: 'ps-5 text-900' }
            },
            cell: ({ row: { original } }) => {
                return (
                    // <OverlayTrigger
                    //     placement="top"
                    //     overlay={isInvalidEmail ? <Tooltip style={{ position: 'fixed' }}>{"Email Address is/about expired"}</Tooltip> : <></>}
                    // >
                    //     <span
                    //         style={{
                    //             color: isInvalidEmail ? 'red' : 'inherit',
                    //             cursor: isInvalidEmail ? 'pointer' : 'default',
                    //         }}
                    //     >
                    //     </span>
                    // </OverlayTrigger>
                    original.email
                );
            }
        },
        {
            accessorKey: 'active',
            header: 'Active',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        {
            accessorKey: 'web_access',
            header: 'Web Access',
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' }
            },
            cell: ({ row: { original } }) => (
                <AccessIconBadge
                    enabled={original.web_access}
                    label="Web Access"
                    icon="globe"
                />
            )
        },
        {
            accessorKey: 'mobile_access',
            header: 'Mobile Access',
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' }
            },
            cell: ({ row: { original } }) => (
                <AccessIconBadge
                    enabled={original.mobile_access}
                    label="Mobile Access"
                    icon="mobile"
                />
            )
        }
        ,
        {
            accessorKey: 'lastlogin',
            header: 'Last Login',
            meta: {
                headerProps: { className: 'text-900' }
            },
            sortingFn: (rowA, rowB) => {
                const a = rowA.original.lastlogin !== '-'
                    ? moment(rowA.original.lastlogin, 'MM/DD/YY HH:mm A')
                    : moment(0);
                const b = rowB.original.lastlogin !== '-'
                    ? moment(rowB.original.lastlogin, 'MM/DD/YY HH:mm A')
                    : moment(0);
                return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
            }
        },
        {
            accessorKey: '',
            header: 'Reset Password',
            meta: {
                headerProps: { className: 'pe-1 text-900' },
                cellProps: { className: 'text-center' }
            },
            cell: ({ row: { original } }) => {
                return <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip style={{ position: 'fixed' }}>{"Reset Password"}</Tooltip>}>
                    <Link onClick={() => handleResetModal(original.id)}>
                        <FontAwesomeIcon icon="pencil-alt" className="fs-11 me-2" />
                    </Link>
                </OverlayTrigger>
            }
        }
    ];
    if (roleId < 4) {
        columns.push({
            accessorKey: 'access_history',
            header: 'Access History',
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' },
            },
            cell: ({ row: { original } }) => (
                <Link onClick={() => handleAccessHistory(original.id, original.name)}>
                    <FontAwesomeIcon icon="eye" className="fs-11 me-2" />
                </Link>
            ),
        });
    }

    // SharedLiving (UI-024): quick path to a caregiver's patient assignments.
    if (roleId <= 4) {
        columns.push({
            accessorKey: 'caregiver_assignments',
            header: 'Patients',
            enableSorting: false,
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' },
            },
            cell: ({ row: { original } }) => {
                if (Number(original.role_id) !== 7) {
                    return <span className="text-400">—</span>;
                }
                return (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip style={{ position: 'fixed' }}>View Caregiver Assignments</Tooltip>}>
                        <Link to={paths.userSharedLivingCaregiverDetail.replace(':user_id', original.id)}>
                            <FontAwesomeIcon icon="user-friends" className="fs-11 me-2" />
                        </Link>
                    </OverlayTrigger>
                );
            },
        });
    }

    const handleResetModal = (userid) => {
        //console.log("PatientFormName " + event.target.id)
        localStorage.setItem("editUserId", userid);
        setShowModal(true);
    };

    const handleAccessHistory = (id, name) => {
        setAccessUserId(id);
        setAccessUsername(name);
        setShowAccessModal(true);
    };

    useEffect(() => {
        fetchFacilityData('');
    }, []);

    async function fetchFacilityData(facilityid) {

        try {
            setLoading(true);
            let tokenStr = localStorage.getItem("accessToken");
            const { data } = await axios.post(`${process.env.REACT_APP_SERVER_URL}` + "/users/list", {}, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            const results = []

            //console.log("Facilties Staff Status " + JSON.stringify(data));
            //const objData = data.data;
            //let groupId = "";
            const roleMapping = {
                7: "SharedLiving Caregiver",
                6: "Day Program User",
                5: "Facility Staff",
                4: "Group Admin",
                3: "PHARMACY Staff",
                2: "Pharmacy Admin",
                1: "System Admin"
            };

            data.forEach((value) => {
                if (facilityid != "") {
                    if (facilityid == value.facility_id) {
                        //groupId = value.group_id;
                        results.push({
                            id: value.id,
                            name: value.username,
                            fullname: value.first_name + ' ' + value.last_name,
                            role: roleMapping[value.role_id],
                            mobile: value.phone,
                            email: value.email,
                            active: value.is_active == 1 ? "Yes" : "No",
                            web_access: Number(value.role_id) === 5 ? Number(value.has_web_access ?? 1) : null,
                            mobile_access: Number(value.role_id) === 5 ? Number(value.has_mobile_access ?? 1) : null,
                            lastlogin: value.last_login_timestamp ? moment(value.last_login_timestamp).format("MM/DD/YY") : "-",
                            email_last_confirm: value.email_last_confirm,
                            facilities : value?.facilities,
                            day_programs: value?.day_programs || value?.dayPrograms || value?.programs || []
                        });
                    }
                }
                else {
                    //groupId = value.group_id;
                    results.push({
                        id: value.id,
                        name: value.username,
                        fullname: value.first_name + ' ' + value.last_name,
                        role: roleMapping[value.role_id],
                        mobile: value.phone,
                        email: value.email,
                        active: value.is_active == 1 ? "Yes" : "No",
                        web_access: Number(value.role_id) === 5 ? Number(value.has_web_access ?? 1) : null,
                        mobile_access: Number(value.role_id) === 5 ? Number(value.has_mobile_access ?? 1) : null,
                        lastlogin: value.last_login_timestamp ? moment(value.last_login_timestamp).format('MM/DD/YY HH:mm A') : "-",
                        email_last_confirm: value.email_last_confirm,
                        role_id: value.role_id,
                        facilities : value?.facilities,
                        day_programs: value?.day_programs || value?.dayPrograms || value?.programs || []
                    });
                }
            });

            //localStorage.setItem("groupId", groupId);
            setAllFacilityStaff(results);

            console.log("Facility Points " + localStorage.getItem("facilitiesData"));
            setGroupOptions([
                { key: 'All Groups', value: '' },
                ...(JSON.parse(localStorage.getItem("groupsData")) || [])
            ]);
        } catch (error) {
            navigate('/error')
        } finally {
            setLoading(false);
        }
    }

    const facilityOptions = useMemo(() => {
        const facilityResults = JSON.parse(localStorage.getItem("facilitiesData")) || [];
        const selectedGroupId = selectedGroup?.value;

        if (!canFilterByGroup || !selectedGroupId) {
            return [
                { key: 'All Facilities', value: '' },
                ...facilityResults
            ];
        }

        return [
            { key: 'All Facilities', value: '' },
            ...facilityResults.filter(facility => Number(facility.group_id) === Number(selectedGroupId))
        ];
    }, [selectedGroup, canFilterByGroup]);

    const facilityStaff = useMemo(() => {
        const facilityResults = JSON.parse(localStorage.getItem("facilitiesData")) || [];
        const selectedGroupId = selectedGroup?.value;
        const selectedFacilityId = selectedFacility?.value;
        const selectedRoleId = selectedRole?.value;

        return allFacilityStaff.filter(user => {
            const userFacilityIds = [
                user.facility_id,
                ...(Array.isArray(user.facilities) ? user.facilities : [])
            ].filter(Boolean).map(Number);

            if (canFilterByGroup && selectedGroupId) {
                const userBelongsToGroup = Number(user.group_id) === Number(selectedGroupId);
                const userFacilityBelongsToGroup = userFacilityIds.some(facilityId => {
                    const facility = facilityResults.find(option => Number(option.value) === Number(facilityId));
                    return Number(facility?.group_id) === Number(selectedGroupId);
                });

                if (!userBelongsToGroup && !userFacilityBelongsToGroup) {
                    return false;
                }
            }

            if (selectedFacilityId && !userFacilityIds.includes(Number(selectedFacilityId))) {
                return false;
            }

            if (selectedRoleId && Number(user.role_id) !== Number(selectedRoleId)) {
                return false;
            }

            return true;
        });
    }, [allFacilityStaff, selectedGroup, selectedFacility, selectedRole, canFilterByGroup]);

    const handleGroupChange = selectedOption => {
        setSelectedGroup(selectedOption);
        setSelectedFacility(null);
    };

    const handleFacilityChange = selectedOption => {
        setSelectedFacility(selectedOption);
    };

    const handleRoleChange = selectedOption => {
        setSelectedRole(selectedOption);
    };

    const table = useAdvanceTable({
        data: facilityStaff,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'User Management ', href: paths.viewFacility, isActive: true }
    ];

    return (
        <>
            {!loading ?
                <>
                <AccessHistory
  show={showAccessModal}
  onHide={() => setShowAccessModal(false)}
  userId={accessUserId}
  username={accessUsername}
/>
                    <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
                    <AdvanceTableProvider {...table}>
                        <Card className="mb-3">
                            <Card.Body className="p-2">
                                <Row className='mt-3 justify-content-between'>
                                    <Col xs="12" md="3" className="mb-3 ml-3">
                                        <AdvanceTableSearchBox placeholder="Search..." />
                                    </Col>
                                    {canFilterByGroup && (
                                        <Col xs="12" md="3" className="mb-3">
                                            <Form.Group>
                                                <ThemedSelect
                                                    name="groupname"
                                                    closeMenuOnSelect={true}
                                                    placeholder='Select Group'
                                                    className="form-control-sm"
                                                    classNamePrefix="react-select"
                                                    options={groupOptions}
                                                    value={selectedGroup}
                                                    getOptionLabel={option => option.key}
                                                    getOptionValue={option => option.value}
                                                    onChange={handleGroupChange}
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            borderColor: "#ced4da",
                                                            backgroundColor: "white",
                                                            height: "calc(1.5em + 0.75rem + 2px)",
                                                            minHeight: "38px",
                                                            boxShadow: "none",
                                                            "&:hover": { borderColor: "#80bdff" }
                                                        }),
                                                        option: (provided, { isFocused, isSelected }) => ({
                                                            ...provided,
                                                            backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                                                            color: isSelected ? "#212529 !important" : "#212529 !important",
                                                            cursor: "pointer",
                                                        }),
                                                        singleValue: (provided) => ({
                                                            ...provided,
                                                            color: "#212529",
                                                        }),
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    )}
                                    <Col xs="12" md={canFilterByGroup ? "3" : "4"} className="mb-3">
                                        <Form.Group>
                                            <ThemedSelect
                                            name="facilityname"
                                            closeMenuOnSelect={true}
                                            placeholder='Select Facility'
                                            className="form-control-sm"
                                            classNamePrefix="react-select"
                                            options={facilityOptions}
                                            value={selectedFacility}
                                            getOptionLabel={option => option.key}
                                            getOptionValue={option => option.value}
                                            onChange={(selectedOption) => {
                                                handleFacilityChange(selectedOption);
                                            }}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderColor: "#ced4da",
                                                    backgroundColor: "white",
                                                    height: "calc(1.5em + 0.75rem + 2px)",
                                                    minHeight: "38px",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#80bdff" }
                                                }),
                                                option: (provided, { isFocused, isSelected }) => ({
                                                    ...provided,
                                                    backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                                                    color: isSelected ? "#212529 !important" : "#212529 !important",
                                                    cursor: "pointer",
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: "#212529",
                                                }),
                                            }}
                                        />
                                        </Form.Group>
                                    </Col>
                                    <Col xs="12" md={canFilterByGroup ? "3" : "4"} className="mb-3">
                                        <Form.Group>
                                            <ThemedSelect
                                                name="rolename"
                                                closeMenuOnSelect={true}
                                                placeholder='Select Role'
                                                className="form-control-sm"
                                                classNamePrefix="react-select"
                                                options={roleOptions}
                                                value={selectedRole}
                                                getOptionLabel={option => option.key}
                                                getOptionValue={option => option.value}
                                                onChange={handleRoleChange}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: "#ced4da",
                                                        backgroundColor: "white",
                                                        height: "calc(1.5em + 0.75rem + 2px)",
                                                        minHeight: "38px",
                                                        boxShadow: "none",
                                                        "&:hover": { borderColor: "#80bdff" }
                                                    }),
                                                    option: (provided, { isFocused, isSelected }) => ({
                                                        ...provided,
                                                        backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                                                        color: isSelected ? "#212529 !important" : "#212529 !important",
                                                        cursor: "pointer",
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: "#212529",
                                                    }),
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col></Col>
                                    <Col></Col>
                                </Row>
                                <Row>
                                    {facilityStaff.length > 0 ? <Col xs="12" className="mb-1 mt-1">
                                        <AdvanceTable
                                            headerClassName="bg-200 text-nowrap align-middle"
                                            rowClassName="align-middle white-space-nowrap"
                                            tableProps={{
                                                size: 'sm',
                                                striped: true,
                                                className: 'fs-10 mb-0 overflow-hidden'
                                            }}
                                        />
                                    </Col> : <p className="text-danger text-center fw-bold">No data available in table</p>}
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <div className="mt-3">
                                    <AdvanceTableFooter
                                        rowInfo
                                        navButtons
                                        rowsPerPageSelection
                                    />
                                </div>
                            </Card.Footer>
                        </Card>
                        <ResetPasswordModal show={showModal} setShow={setShowModal} />
                    </AdvanceTableProvider>
                </>
                : <ShimmerUI />}
        </>
    );
};

export default ViewFacilityStaff;

